export default __webpack_public_path__ + "static/media/pin.238f4a94.svg";